(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sidebar-bestsellers"]) return;
  try {
    
$(document).ready(function(){
var top_products_count = $('.top-products li').length;
      if(top_products_count > 1) { $('.top_products_nav').css('display','block');}
      else {$('.top_products_nav').css('display','none');}
      var top_products = $(".top-products");
      top_products.owlCarousel({
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:false
      });
      // Custom Navigation Events
      $(".top_products_nav .next").click(function(){
        top_products.trigger('owl.next');
      })
      $(".top_products_nav .prev").click(function(){
        top_products.trigger('owl.prev');
      })             
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-promoimage"]) return;
  try {
    
$(document).ready(function(){
     $("#promo-carousel").owlCarousel({ 
      autoPlay: 3000, //Set AutoPlay to 3 seconds 
        items: 1,
        itemsCustom: false,
        itemsDesktop: [1199, 1],
        itemsDesktopSmall: [980, 1],
        itemsTablet: [630, 1],
        itemsTabletSmall: false,
        itemsMobile: [479, 1],
        singleItem: false,
        itemsScaleUp: false,
        responsive: true,
        responsiveRefreshRate: 200,
        responsiveBaseWidth: window,
        autoPlay: false,
        stopOnHover: false,
        navigation: false,
        pagination:true
 
  });
});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["warranty-form"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.warranty-form');

    sections.forEach(function (section) {
      var form = section.querySelector('.warranty-form__form');
      if (!form) return;

      var purchaseInput = form.querySelector('[data-warranty-date]');
      var purchaseHidden = form.querySelector('[data-warranty-date-formatted]');
      var dobInput = form.querySelector('[data-warranty-dob]');
      var dobHidden = form.querySelector('[data-warranty-dob-formatted]');

      function pad(num) {
        return String(num).padStart(2, '0');
      }

      function getLocalDateString(date) {
        return (
          date.getFullYear() +
          '-' +
          pad(date.getMonth() + 1) +
          '-' +
          pad(date.getDate())
        );
      }

      function formatAmericanDate(value) {
        if (!value) return '';
        var dateParts = value.split('-');
        if (dateParts.length < 3) return value;
        return dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0];
      }

      function syncPurchaseDate() {
        if (!purchaseInput || !purchaseHidden) return;
        purchaseHidden.value = formatAmericanDate(purchaseInput.value);
      }

      function syncDob() {
        if (!dobInput || !dobHidden) return;
        dobHidden.value = formatAmericanDate(dobInput.value);
      }

      if (purchaseInput) {
        purchaseInput.setAttribute('max', getLocalDateString(new Date()));
        purchaseInput.addEventListener('change', syncPurchaseDate);
        purchaseInput.addEventListener('input', syncPurchaseDate);
        syncPurchaseDate();
      }

      if (dobInput) {
        dobInput.setAttribute('max', getLocalDateString(new Date()));
        dobInput.addEventListener('change', syncDob);
        dobInput.addEventListener('input', syncDob);
        syncDob();
      }

      function clearError(field) {
        field.classList.remove('is-invalid');
        field.removeAttribute('aria-invalid');
        var existing = field.parentNode.querySelector('.warranty-form__error-message');
        if (existing) existing.remove();
      }

      function showError(field, message) {
        field.classList.add('is-invalid');
        field.setAttribute('aria-invalid', 'true');
        var existing = field.parentNode.querySelector('.warranty-form__error-message');
        if (existing) existing.remove();
        var error = document.createElement('span');
        error.className = 'warranty-form__error-message';
        error.textContent = message;
        field.parentNode.appendChild(error);
      }

      function validateField(field) {
        clearError(field);

        var value = (field.value || '').trim();

        if (field.hasAttribute('required') && !value) {
          showError(field, 'This field is required.');
          return false;
        }

        if (field.type === 'email' && value) {
          var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(value)) {
            showError(field, 'Please enter a valid email address.');
            return false;
          }
        }

        if (field.type === 'number' && value) {
          var num = Number(value);
          var min = field.getAttribute('min');
          var max = field.getAttribute('max');
          if (Number.isNaN(num)) {
            showError(field, 'Please enter a valid number.');
            return false;
          }
          if (min !== null && num < Number(min)) {
            showError(field, 'Value must be at least ' + min + '.');
            return false;
          }
          if (max !== null && num > Number(max)) {
            showError(field, 'Value must be at most ' + max + '.');
            return false;
          }
        }

        return true;
      }

      var fields = form.querySelectorAll('.warranty-form__input');

      fields.forEach(function (field) {
        field.addEventListener('blur', function () {
          validateField(field);
        });
        field.addEventListener('input', function () {
          if (field.classList.contains('is-invalid')) {
            validateField(field);
          }
        });
      });

      form.addEventListener('submit', function (event) {
        var firstInvalid = null;

        fields.forEach(function (field) {
          var isValid = validateField(field);
          if (!isValid && !firstInvalid) {
            firstInvalid = field;
          }
        });

        if (firstInvalid) {
          event.preventDefault();
          firstInvalid.focus();
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }

        syncPurchaseDate();
        syncDob();

        var submitButton = form.querySelector('.warranty-form__button');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.dataset.originalLabel = submitButton.textContent;
          submitButton.textContent = 'Submitting...';
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
